import React from 'react';
import Section from './section/Section';
import ContactUs from './section/ContactUs';
import SectionAlternative from './section/SectionAlternative';
import { Element } from 'react-scroll';

const Wrapper = (props) => {
  return (
    <div>
      <Element name="about" className="element">
        <Section sectionId="one" sectionStyle="style1" collection={props.collections[0]} href="about" next="portfolio" />
      </Element>
      <Element name="portfolio" className="element">
        <SectionAlternative sectionId="two" sectionStyle="right style2" collection={props.collections[1]} href="portfolio" next="services" />
      </Element>
      <Element name="services" className="element">
        <SectionAlternative sectionId="two" sectionStyle="left style2" collection={props.collections[2]} next="contact" />
      </Element>
      <Element name="contact" className="element">
        <ContactUs sectionId="one" sectionStyle="style1" collection={props.collections[3]} />
      </Element>
    </div>
  );
}

export default Wrapper;



// WEBPACK FOOTER //
// ./src/components/wrapper/Wrapper.js